import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { mapEasingToNativeEasing } from './easing.mjs';
function animateStyle(element, valueName, keyframes) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 300 : _ref$duration,
    _ref$repeat = _ref.repeat,
    repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
    ease = _ref.ease,
    times = _ref.times;
  var keyframeOptions = _defineProperty({}, valueName, keyframes);
  if (times) keyframeOptions.offset = times;
  var easing = mapEasingToNativeEasing(ease);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */
  if (Array.isArray(easing)) keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay,
    duration: duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
export { animateStyle };